/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meal-plan.reducer';

export const MealPlanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mealPlanEntity = useAppSelector(state => state.mealPlan.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mealPlanDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mealPlan.detail.title">MealPlan</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mealPlan.id">Id</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.mealPlan.active">Active</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.mealPlan.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.mealPlan.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.lastupdated}</dd>
          <dt>
            <span id="plannedAt">
              <Translate contentKey="tinyMedicRestApp.mealPlan.plannedAt">Planned At</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.plannedAt}</dd>
          <dt>
            <span id="delveredAt">
              <Translate contentKey="tinyMedicRestApp.mealPlan.delveredAt">Delvered At</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.delveredAt}</dd>
          <dt>
            <span id="consumedAt">
              <Translate contentKey="tinyMedicRestApp.mealPlan.consumedAt">Consumed At</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.consumedAt}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.mealPlan.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.instructions}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.mealPlan.status">Status</Translate>
            </span>
          </dt>
          <dd>{mealPlanEntity.status}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealPlan.nutritionPlan">Nutrition Plan</Translate>
          </dt>
          <dd>{mealPlanEntity.nutritionPlan ? mealPlanEntity.nutritionPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealPlan.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{mealPlanEntity.treatmentPlan ? mealPlanEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealPlan.nutritionOrder">Nutrition Order</Translate>
          </dt>
          <dd>{mealPlanEntity.nutritionOrder ? mealPlanEntity.nutritionOrder.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/meal-plan" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meal-plan/${mealPlanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MealPlanDetail;
